import { useList, useStore, useStoreMap } from 'effector-react';
import { styled } from 'linaria/react';
import React from 'react';
import { addNamesToggleChange, clickPrettify, debugSidsToggleChange, factoriesChange, importNameChange, prettierFx, reactSSRToggleChange } from '.';
import { LoadingIcon } from '../components/Icons/LoadingIcon';
import { selectVersion, selectViewLib } from '../editor';
import { $packageVersions, $version, $viewLibraries } from '../editor/state';
import { $addNames, $debugSids, $factories, $importName, $reactSsr, $viewLib } from '../settings/state';
export const PrettifyButton = () => {
  const {
    disabled,
    pending
  } = useStoreMap({
    store: prettierFx.pending,
    keys: [],
    fn: pending => ({
      disabled: pending,
      pending
    })
  });
  return <Button disabled={disabled} onClick={clickPrettify} style={{
    padding: 0,
    flex: '0 0 100px',
    height: 28,
    lineHeight: 0,
    margin: '0 10px 0 3px',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    justifyContent: 'center'
  }}>
      {pending && <LoadingIcon style={{
      marginRight: 10
    }} />}
      Prettify
    </Button>;
};
export const Settings = () => <SettingsGroup>
    <Section>
      <Label>
        <div className="versions">
          <select value={useStore($version)} onChange={e => selectVersion(e.currentTarget.value)}>
            {useList($packageVersions, item => <option value={item}>{item}</option>)}
          </select>
        </div>
        Effector version
      </Label>
    </Section>
    <Section>
      <Label>
        <div>
          <select value={useStore($viewLib)} onChange={e => selectViewLib(e.currentTarget.value)}>
            {useList($viewLibraries, item => <option value={item}>{item}</option>)}
          </select>
        </div>
        View library
      </Label>
    </Section>
    <Section>
      <Label>
        <div>
          <input type="checkbox" checked={useStore($debugSids) ?? false} onChange={debugSidsToggleChange} />
        </div>
        Debug SIDs
      </Label>
      <Label>
        <div>
          <input type="checkbox" checked={useStore($reactSsr) ?? false} onChange={reactSSRToggleChange} />
        </div>
        React SSR
      </Label>
      <Label>
        <div>
          <input type="checkbox" checked={useStore($addNames) ?? false} onChange={addNamesToggleChange} />
        </div>
        Add names
      </Label>
      <Label>
        <div>
          <input type="text" value={useStore($importName) ?? ''} onChange={importNameChange} />
        </div>
        Import name
      </Label>
      <Label>
        <div>
          <input type="text" value={useStore($factories).join(', ')} onChange={e => factoriesChange(e.currentTarget.value.split(',').map(e => e.trim()).filter(Boolean))} />
        </div>
        <div>
          Factories <span>ex.:(first, second)</span>
        </div>
      </Label>
    </Section>
  </SettingsGroup>;
const SettingsGroup = /*#__PURE__*/styled("div")({
  name: "SettingsGroup",
  class: "szahxg7"
});
const Label = /*#__PURE__*/styled("label")({
  name: "Label",
  class: "l1pd25xc"
});
export const Section = /*#__PURE__*/styled("section")({
  name: "Section",
  class: "s3sr5fp"
});
const Button = /*#__PURE__*/styled("button")({
  name: "Button",
  class: "b1llkr69"
});